module.exports = __webpack_public_path__ + "img/chips10.45c692e2.webp";